import { render } from "./UpdateIECapabilities.vue?vue&type=template&id=6fbabb62&scoped=true"
import script from "./UpdateIECapabilities.vue?vue&type=script&lang=js"
export * from "./UpdateIECapabilities.vue?vue&type=script&lang=js"

import "./UpdateIECapabilities.vue?vue&type=style&index=0&id=6fbabb62&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fbabb62"]])

export default __exports__